import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useRetrieveTeam } from "../ApiProvider";
import { useRetrieveExternalMatch, useUpdateExternalMatch, } from "../api/MatchApiProvider";
import { useRetrieveUserExternalMatchPermissions } from "../api/PermissionApiProvider";
import { ErrorView } from "../nav/Error";
import { Loading } from "../nav/Loading";
import { NotFound } from "../nav/NotFound";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { useNumericParams } from "../utils/useNumericParams";
import { ExternalMatchForm } from "./ExternalMatchForm";
export var UpdateExternalMatch = function () {
    var id = useNumericParams().id;
    var _a = useRetrieveUserExternalMatchPermissions({ externalMatchId: id }), userExternalMatchPermissions = _a.data, userExternalMatchPermissionsIsLoading = _a.isLoading, userExternalMatchPermissionsError = _a.error;
    var _b = (userExternalMatchPermissions || {}).canModify, canModify = _b === void 0 ? false : _b;
    var _c = useRetrieveExternalMatch({ id: id, enabled: canModify }), useRetrieveExternalMatchIsLoading = _c.isLoading, useRetrieveExternalMatchError = _c.error, externalMatch = _c.data;
    var _d = useRetrieveTeam({ id: externalMatch === null || externalMatch === void 0 ? void 0 : externalMatch.team }), team = _d.data, teamError = _d.error, teamIsLoading = _d.isLoading;
    var navigate = useNavigate();
    var mutation = useUpdateExternalMatch({
        id: id,
        team: team,
        onMutate: function () { },
        onSuccess: function () {
            return navigate("/teams/".concat(externalMatch === null || externalMatch === void 0 ? void 0 : externalMatch.team, "/external-matches/").concat(id, "/"));
        },
        onError: function () { },
    });
    var onSubmit = function (externalMatch) {
        mutation.mutate(externalMatch);
    };
    if (userExternalMatchPermissionsIsLoading) {
        return _jsx(Loading, {});
    }
    if (userExternalMatchPermissionsError) {
        return _jsx(ErrorView, { error: userExternalMatchPermissionsError });
    }
    if (!canModify) {
        return _jsx(NotFound, {});
    }
    if ((useRetrieveExternalMatchIsLoading && canModify) || teamIsLoading) {
        return _jsx(Loading, {});
    }
    if (useRetrieveExternalMatchError ||
        !(externalMatch === null || externalMatch === void 0 ? void 0 : externalMatch.team) ||
        !team ||
        teamError) {
        return _jsx(ErrorView, { error: useRetrieveExternalMatchError });
    }
    return (_jsxs(React.Fragment, { children: [_jsx(ErrorSnackbar, { open: mutation.isError, message: "Failed to update External Match. Please try again." }), _jsx(Typography, { variant: "h6", children: _jsxs("strong", { children: ["Update External Match for ", team.name] }) }), _jsx(ExternalMatchForm, { externalMatch: externalMatch, team: team, onSubmit: onSubmit })] }));
};
